import { render, staticRenderFns } from "./Loot.vue?vue&type=template&id=051d6490&"
import script from "./Loot.vue?vue&type=script&lang=js&"
export * from "./Loot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports